<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vbCQmB/tc-custom/9781514005057.jpg?1688600165443" alt="This image is the cover for the book Philippians, Tyndale New Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Philippians, Tyndale New Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The letter to the Philippians illuminates a warm relationship between the apostle Paul and the Philippian believers.</strong> Despite difficult situations being experienced on both sides, Paul finds ample reason to celebrate what God in Christ has done and is doing in the believers' lives.</p> <p>Jeannine K. Brown's commentary on Philippians explores the themes of this epistle and how its message is still relevant to Christians in the twenty-first century. Brown shows how motifs of joy, contentment, and unity abound as Paul reminds the Philippians of the supreme value of knowing Jesus the Messiah, and she highlights their significance for shaping the contemporary church toward living more deeply in its identity in Christ.</p> <p>This Tyndale New Testament commentary examines the text section-by-section—exploring the context in which it was written, providing thoughtful commentary on the letter to the Philippians, and then unpacking its theology. It will leave you with a thorough understanding of the content and structure of Paul's writing, as well as its meaning and continued relevance.</p> <p>The Tyndale New Testament Commentaries are ideal resources for students and teachers of theology, as well as for preachers and individual Christians looking to delve deeper into the riches of Scripture. Insightful and comprehensive, Jeannine K. Brown's commentary on Philippians is a brilliant introduction that will give you a renewed appreciation for this rich Pauline epistle and a greater knowledge of why it is important to the Christian faith.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeannine K. Brown, Eckhard J. Schnabel, Nicholas Perrin
      </h2>
      
      <p class="authorDescription body article"><p>Jeannine K. Brown is professor of New Testament at Bethel Seminary in St. Paul, Minnesota. Her books include <em>Scripture as Communication</em>, <em>The Gospels as Stories</em>, and biblical commentaries on the Gospel of Matthew. She is also a coeditor of the second edition of <em>The Dictionary of Jesus and the Gospels</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?414083f6